export interface FuelData {
  name: string
  unit: string
  co2: number
  energy: number
  calculationLabel?: string
}
interface ResultData {
  name: string
  totalCost: number
  co2Impact: number
  energyUsage: number
}

export const fuelData: FuelData[] = [
  { name: 'Bensin', unit: 'liter', co2: 2.72376, energy: 8.94, calculationLabel: 'Bensin MK1' },
  { name: 'Diesel', unit: 'liter', co2: 3.21842, energy: 9.8, calculationLabel: 'Diesel MK1' },
  { name: 'E85', unit: 'liter', co2: 1.0764, energy: 6.52 },
  { name: 'Fordonsgas', unit: 'kg', co2: 0.03388, energy: 13.67 },
  { name: 'El', unit: 'kWh', co2: 0.007, energy: 1, calculationLabel: 'El (svensk elmix)' },
  { name: 'HVO100', unit: 'liter', co2: 0.5456, energy: 9.44 },
  { name: 'FAME100', unit: 'liter', co2: 1.1583, energy: 9.17 },
]

export function useFuelCalulator() {
  const selectedFuel = ref<FuelData>()
  const selectedAmount = ref<number>()
  const selectedCost = ref<number>()
  const comparisonDimension = ref<'co2Impact' | 'energyContent'>('energyContent')
  // const checked = ref<boolean>(false)

  function getSuffix(price?: string) {
    price = price ?? ''

    if (selectedFuel.value?.unit) {
      return `${price}/${selectedFuel.value?.unit}`
    } else {
      return `${price}`
    }
  }

  const calculateFuel = (fuel: FuelData, amount: number) => {
    return {
      co2: fuel.co2 * amount,
      energy: fuel.energy * amount,
    }
  }

  const result = computed(() => {
    if (!selectedAmount.value) return null

    const selectedAmountValue = selectedAmount.value || 0
    const totalCost = selectedAmountValue * (selectedCost.value || 0)
    const co2Impact = selectedAmountValue * (selectedFuel.value?.co2 || 0)
    const energyContent = selectedAmountValue * (selectedFuel.value?.energy || 0)

    return {
      totalCost,
      co2Impact,
      energyContent,
    }
  })
  const comparison = computed(() => {
    if (!result.value) return null
    const comparisonData = fuelData.map((fuel) => {
      const fuelAmount =
        comparisonDimension.value === 'co2Impact'
          ? (result.value?.co2Impact || 0) / fuel.co2
          : (result.value?.energyContent || 0) / fuel.energy

      const energyContent = fuelAmount * fuel.energy
      const co2Impact = fuelAmount * fuel.co2

      return {
        name: fuel.name,
        co2Impact,
        energyContent,
        fuelAmount,
        unit: fuel.unit,
        calculationLabel: fuel?.calculationLabel,
      }
    })
    const maxenergyContent = Math.max(...comparisonData.map((fuel) => fuel.energyContent))
    const maxco2Impact = Math.max(...comparisonData.map((fuel) => fuel.co2Impact))

    return comparisonData.map((comparisonFuel) => ({
      ...comparisonFuel,
      energyContentRelative: comparisonFuel.energyContent / maxenergyContent,
      co2ImpactRelative: comparisonFuel.co2Impact / maxco2Impact,
    }))
  })
  const resetCalculator = () => {
    selectedFuel.value = undefined
    selectedAmount.value = undefined
    selectedCost.value = undefined
  }
  return {
    fuelData,
    calculateFuel,
    selectedFuel,
    selectedAmount,
    selectedCost,
    comparisonDimension,
    result,
    comparison,
    resetCalculator,
  }
}
